const CONNECT_REQUEST = 'script/req/connecting';

const STATUS_REQUEST = 'extension/req/status';
const TABS_POST = 'extension/req/post/tabs';
const TABS_POST_SUCCESS = 'extension/res/tabs-success';

const STATUS_RESPONSE = 'app/res/status';
const STATUS_READY = 'ready';

export const EXT_ID = process.env.EXTENSION_ID;
export const APP_DOMAIN = process.env.APP_DOMAIN;

export const msgs = {
  CONNECT_REQUEST,
  STATUS_REQUEST,
  TABS_POST,
  STATUS_RESPONSE,
  STATUS_READY,
  TABS_POST_SUCCESS
};



// WEBPACK FOOTER //
// ./src/extension/src/messages.js